import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
export const TimeField: FieldComponent<any, any> = ({
  onChange,
  isActive,
  value,
  hasTooltip,
  disabled,
  mui,
  column,
  compact,
}) => {

  return (
    <>

    </>
  );
};

TimeField.includes = (query, value) => true;

TimeField.comparator = () => 0;

TimeField.FilterRenderer = TimeFilter;
